import {
  AdminUsersResponseType,
  ApiClient,
  ApiErrorMessage,
  CategoryResponseType,
  MailingListResponseType,
  PhrasesResponseType,
  TrainGroupsResponseType,
  TrainsResponseType
} from './ApiClient';

export const CreateAdminUsersApi = async (
  body: object
): Promise<AdminUsersResponseType> => {
  try {
    const response = await ApiClient.post('/admin/admin_users', body, {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem('access-token')}`
      }
    });
    return { success: true, data: response.data, message: null };
  } catch (err) {
    const error = ApiErrorMessage(err);
    return { success: false, data: null, message: error?.data };
  }
};

export const CreateTrainsApi = async (
  body: object
): Promise<TrainsResponseType> => {
  try {
    const response = await ApiClient.post('/admin/trains', body, {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem('access-token')}`
      }
    });
    return { success: true, data: response.data, message: null };
  } catch (err) {
    const error = ApiErrorMessage(err);
    return { success: false, data: null, message: error?.data };
  }
};

export const CreateTrainGroupsApi = async (
  body: object
): Promise<TrainGroupsResponseType> => {
  try {
    const response = await ApiClient.post('/admin/train_groups', body, {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem('access-token')}`
      }
    });
    return { success: true, data: response.data, message: null };
  } catch (err) {
    const error = ApiErrorMessage(err);
    return { success: false, data: null, message: error?.data };
  }
};

export const CreateCategoriesApi = async (
  body: object
): Promise<CategoryResponseType> => {
  try {
    const response = await ApiClient.post('/admin/categories', body, {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem('access-token')}`
      }
    });
    return { success: true, data: response.data, message: null };
  } catch (err) {
    const error = ApiErrorMessage(err);
    return { success: false, data: null, message: error?.data };
  }
};

export const CreatePhrasesApi = async (
  body: object
): Promise<PhrasesResponseType> => {
  try {
    const response = await ApiClient.post('/admin/phrases', body, {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem('access-token')}`
      }
    });
    return { success: true, data: response.data, message: null };
  } catch (err) {
    const error = ApiErrorMessage(err);
    return { success: false, data: null, message: error?.data };
  }
};

export const CreateMailingListsApi = async (
  body: object
): Promise<MailingListResponseType> => {
  try {
    const response = await ApiClient.post('/admin/mailinglists', body, {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem('access-token')}`
      }
    });
    return { success: true, data: response.data, message: null };
  } catch (err) {
    const error = ApiErrorMessage(err);
    return { success: false, data: null, message: error?.data };
  }
};
